// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"3eb67377","352":"e5c7ac30","765":"12f97a62"}[chunkId] + ".chunk.css";
};